import axios from 'axios'
import api from '@/api'

export const employeePositionsModule = {
    namespaced: true,

    state:() => ({
        isLoading: true,
        positions: null,
    }),

    mutations: {
        setPositions(state, data) {
            state.positions = data
        }
    },

    actions: {
        getPositions({ state, commit }, shop_code) {
            state.isLoading = true

            axios
            .get(`${api}projects/tcode/${shop_code}/shift-roles/`,
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                state.isLoading = false
                commit('setPositions', response.data)
            })
            .catch((error) => {
                console.log(error);
                state.isLoading = false
            });
        },

        async setPositionTimes({ state, commit }, data) {
            return axios
            .patch(`${api}projects/tcode/${data.shop_code}/shift-roles/${data.id}/`,
            {
                payment_from: data.payment_from,
                payment_to: data.payment_to,
                payment_weekend_from: data.payment_weekend_from,
                payment_weekend_to: data.payment_weekend_to
            },
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                state.isLoading = false

                if(response.status == 200) {
                    return true
                } else {
                    return false
                }
            })
            .catch((error) => {
                console.log(error);
                state.isLoading = false

                return false
            });
        },

        async setPayRate({ state }, data) {
            return axios
            .patch(`${api}projects/tcode/${data.shop_code}/shift-roles/${data.id}/`,
            {
                pay_rate: data.pay_rate
            },
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                state.isLoading = false

                if(response.status == 200) {
                    return true
                } else {
                    return false
                }
                // commit('setPositions', response.data)
            })
            .catch((error) => {
                console.log(error);
                state.isLoading = false

                return false
            });
        }
    }
}